export default __webpack_public_path__ + "static/media/placeholder.37ed31db.jpg";